
import { Injectable, Injector, OnDestroy } from '@angular/core';


import { environment } from 'src/environments/environment';
import { AppSetting } from 'src/modules/models/settings/casual-portal/app-setting';

import { AuthService } from '../auth-service';
import { Store } from '@ngrx/store';
import { filter, takeUntil } from 'rxjs/operators';
import { ICart } from 'src/modules/store';
import { Contact } from 'src/modules/models/client/contact';
import { SetB2CContact, SetContact, SetContactFromSilentLogin, SignOut } from 'src/modules/store/actions';
import { CustomerService } from 'src/modules/services/customer.service';
import { Client, CommunicationMethod } from 'src/modules/models/client/client';
import { SetCIAMDataLoaded, SetCIAMReturnUrl } from 'src/modules/store/loading/actions';

import { MsalBroadcastService, MsalService } from '@azure/msal-angular';
import { b2cPolicies, editProfileMsalInstance, editProfileRequest, silentRequest } from './utils/auth-config';
import { AccountInfo, AuthenticationResult, EventType, InteractionStatus, Logger, LogLevel, RedirectRequest } from '@azure/msal-browser';
import { Subject } from 'rxjs';
import { Utility } from 'src/modules/utility';
import { ContactFilters } from 'src/modules/models/filters/contact-filters';


@Injectable({
    providedIn: 'root',
})
export class AzureCiamAuthService implements AuthService, OnDestroy {

    appsetting = environment.AppSetting as AppSetting;
    loggedInDBContact: Contact;
    b2cContact: Contact;

    private store: Store<any>
    private customerService: CustomerService;
    private injector: Injector;

    private intervalId: any;
    private checkInterval = 1000 * 60 * 5; // Example interval time

    //CIAM
    //private optMsalProvider: MsalServiceProvider;
    private authService: MsalService
    private msalBroadcastService: MsalBroadcastService

    private readonly _destroying$ = new Subject<void>();
    private msalInstance;

    public loggedInAccounts: AccountInfo[] = [];
    public silentLoginProcessing: boolean = false;
    private loginIsProcessing = false;

    dependencyLoaded = false;
    constructor() {

    }




    async init(injector: Injector, st: Store<any>, customerService: CustomerService): Promise<void> {
        this.store = st;
        this.customerService = customerService;
        this.injector = injector;
        // this.optMsalProvider = injector.get(MsalServiceProvider);

        this.authService = injector.get(MsalService);
        this.msalBroadcastService = injector.get(MsalBroadcastService);
        this.msalInstance = this.authService.instance;



        if (!this.dependencyLoaded) {
            this.dependencyLoaded = true;

            this.store.select('cart').pipe().subscribe((st: ICart) => {
                this.b2cContact = st.b2cContact;
                this.loggedInDBContact = st.contact;
            })
            this.initializeCIAM();
        }

        console.log(`Init Azure CIAM`);
        await this.msalInstance.handleRedirectPromise()

    }


    async silentLogin(fromCiamFlow?: boolean): Promise<void> {
        console.log(`silentLogin Azure CIAM`);
        if (!this.silentLoginProcessing) {
            this.silentLoginProcessing = true;
            this.silentLoginRequestSend(fromCiamFlow);
        }
    }
    async aquireTokenSilent(fromCiamFlow?: boolean): Promise<void> {
        console.log(`aquireTokenSilent`);
        if (!this.silentLoginProcessing) {
            this.silentLoginProcessing = true;
            this.store.dispatch(new SetCIAMDataLoaded(false));
            var res = await this.msalInstance.handleRedirectPromise()

            //  if (fromCiamFlow)
            {
                var req = {
                    scopes: ['openid', 'profile'],//, 'offline_access',
                    account: undefined
                }
                if (res) {
                    req.account = res.account;
                }
                this.authService.acquireTokenSilent(req).subscribe({
                    next: async (result: AuthenticationResult) => {
                        console.log('acquireTokenSilent succeeded!');
                        this.silentLoginProcessing = false;
                        if (result && result.account) {
                            await this.processClaim(result.account)
                        }

                    },
                    error: (error: any) => {
                        console.log(error);
                        this.silentLoginProcessing = false;
                        if (fromCiamFlow) {
                            this.loginActionClick()
                        } else {

                            this.store.dispatch(new SetCIAMDataLoaded(true));
                            if (error && error['errorMessage'] && error['errorMessage'].indexOf('User does not have an existing session')) {
                                if (this.b2cContact && this.b2cContact?.ssoContactRef) {
                                    this.store.dispatch(new SetB2CContact(undefined));
                                    let defaultContact = new Contact();
                                    defaultContact.firstName = "";
                                    defaultContact.profilePicture = "";
                                    this.store.dispatch(new SetContactFromSilentLogin(defaultContact, null, null, null, null, null));
                                    this.msalInstance.setActiveAccount(null);
                                }
                            }

                        }
                    },
                });

            }
        }
    }
    async loginRedirect(): Promise<void> {
        console.log(`Login with azure ciam`);
        if (!this.loginIsProcessing) {
            this.loginIsProcessing = true;

            this.loginActionClick()
        } else {
            setTimeout(() => {
                this.loginIsProcessing = false;
            }, 2000);
        }
    }
    //test
    async logout(callback?: () => void): Promise<void> {
        console.log('Logout from azure');
        // Implement logout logic
        this.handleLogout(callback)
    }

    async profileRedirect(): Promise<void> {
        console.log(`Azure Profile Redirect`);
        // var _redirectUrl = encodeURIComponent(environment.ApiUrl + '/Customer/Profile');
        await editProfileMsalInstance.initialize();
        editProfileMsalInstance
            .handleRedirectPromise()
            .then((authResult) => {
                editProfileMsalInstance.loginRedirect(
                    editProfileRequest as RedirectRequest
                );
            })
            .catch((err) => {
                // TODO: Handle errors
                console.log(err);
            });
    }
    async changePasswordRedirect(): Promise<void> {
        console.log(`azure Change Password Redirect`);
        // var _redirectUrl = encodeURIComponent(environment.ApiUrl + '/Customer/Profile');
        await editProfileMsalInstance.initialize();
        editProfileMsalInstance
            .handleRedirectPromise()
            .then((authResult) => {
                editProfileMsalInstance.loginRedirect(
                    editProfileRequest as RedirectRequest
                );
            })
            .catch((err) => {
                // TODO: Handle errors
                console.log(err);
            });
    }
    ngOnDestroy(): void {

        this._destroying$.next(undefined);
        this._destroying$.complete();

    }

    getSetupCustomerRedirectUrl(c: Contact): Promise<string> {
        return new Promise((resolve, reject) => {
            resolve(environment.ApiUrl + '/Booking/Casual#/client/setup');
        });
    }

    getSSOContactRef(c: Contact): string {
        return (c?.ssoContactRef ?? '')
    }
    /************************************************************************************************************************ */
    private async initializeCIAM() {
        this.msalBroadcastService.inProgress$
            .pipe(
                filter(
                    (status: InteractionStatus) => status === InteractionStatus.None
                ),
                takeUntil(this._destroying$)
            )
            .subscribe(() => {
                this.setAccounts();
            });
        /*
              this.msalInstance.addEventCallback((event: any) => {
                  // set active account after redirect
                  if (
                      (event.eventType === EventType.LOGIN_SUCCESS ||
                          event.eventType === EventType.ACQUIRE_TOKEN_SUCCESS ||
                          event.eventType === EventType.SSO_SILENT_SUCCESS) &&
                      event?.payload?.account
                  ) {
                      const account = event.payload.account;
                      this.msalInstance.setActiveAccount(account);
                      console.log('SSO event capture:')
                      console.log(event)

                      let payload = event.payload as AuthenticationResult;
                      let idtoken = payload.idTokenClaims;// as IdTokenClaimsWithPolicyId;

                      if (idtoken["acr"] === b2cPolicies.names.signUpSignIn || idtoken["tfp"] === b2cPolicies.names.signUpSignIn) {
                          console.log('SSO signUpSignIn')
                          this.authService.instance.setActiveAccount(payload.account);
                      }
                      if (idtoken["acr"] === b2cPolicies.names.editProfile || idtoken["tfp"] === b2cPolicies.names.editProfile) {
                          console.log('SSO editProfile')
                          this.authService.instance.setActiveAccount(payload.account);
                      }

                  }

                 if (event.eventType === EventType.SSO_SILENT_FAILURE && event.error?.errorCode === 'monitor_window_timeout')
                   {
                     this.msalInstance.acquireTokenRedirect();
                   }
              });*/


        await this.authService.instance.initialize();
        var res = await this.msalInstance.handleRedirectPromise()
        if (res) {
            this.msalInstance.setActiveAccount(res.account);

        }
        // Account selection logic is app dependent. Adjust as needed for different use cases.
        // Set active acccount on page load
        let account = this.msalInstance.getActiveAccount();
        if (account == null) {
            const _accList = this.msalInstance.getAllAccounts();
            if (_accList.length > 0) {
                this.msalInstance.setActiveAccount(_accList[0]);
                account = (_accList[0])
            }
        }
        if (account != null) {
            // await this.processClaim(account)
        } else {
            console.log("No active account found, proceeding with login or silent login");
        }
        this.msalInstance.setLogger(new Logger({
            loggerCallback: (level, message, containsPii) => {
                console.log(level, message, containsPii);
            },
            logLevel: LogLevel.Verbose,
            piiLoggingEnabled: false
        }));

        /*this.msalInstance
            .handleRedirectPromise()
            .then((authResult: any) => {
                this.silentLoginRequestSend(false)
            })
            .catch((err: any) => {
                // TODO: Handle errors
                console.log(err);
                // retry one more time
                /!*   setTimeout(() => {
                    this.silentLoginRequestSend()
                  }, 1000); *!/

            });
             const accounts = this.msalInstance.getAllAccounts();
        if (accounts.length > 0) {
            //this.msalInstance.setActiveAccount(accounts[0]);
        }
            */
    }
    setAccounts() {
        this.loggedInAccounts = this.msalInstance.getAllAccounts();
    }


    private async loginActionClick() {
        try {
            if (!this.msalInstance) {
                console.error("MSAL instance is not initialized");
                return;
            }
            console.log("Login redirect");
            await this.msalInstance.handleRedirectPromise()
            this.authService.loginRedirect().subscribe();
            this.loginIsProcessing = false;

            /* await this.msalInstance.handleRedirectPromise()
            const account = this.msalInstance.getActiveAccount();
            console.log("No active account found, proceeding with login or silent login");

            this.azureSilentLogin(
                true,
                () => {
                    this.initialized = true;
                    this.loginIsProcessing = false;
                    this.setAccounts();
                },
                async () => {
                    console.log("Silent login failed, redirecting to login page");
                    await this.msalInstance.handleRedirectPromise()
                    this.authService.loginRedirect();
                }
            ); */

        } catch (err) {
            this.loginIsProcessing = false;
            console.error("Error during login action:", err);
            /* await this.msalInstance.handleRedirectPromise()
            this.authService.loginRedirect(); */
        }
    }


    private silentLoginRequestSend(fromCiamFlow: boolean) {
        // if (!fromCiamFlow) {
        //azure avoid this step since  init does active account validation
        this.azureSilentLogin(fromCiamFlow,
            () => {
                this.silentLoginProcessing = false;
                this.setAccounts();
            },
            () => {
                console.log('silent login failed');
                this.silentLoginProcessing = false;
                this.setAccounts();
            }
        );
        // }
    }


    private async handleLogout(callback?: () => void) {
        if (window.location.href.includes('client/setup') ||
            window.location.href.includes('#/confirm-booking') ||
            window.location.href.includes('#/booking-cart')
        ) {
            this.store.dispatch(
                new SetCIAMReturnUrl(environment.ApiUrl));
        } else if (window.location.href.includes('Booking/Regular')) {
            this.store.dispatch(
                new SetCIAMReturnUrl(window.location.href.split('#/')[0]));
        } else {
            this.store.dispatch(
                new SetCIAMReturnUrl(
                    window.location.href.replace('/Customer/Index#/', '#/')
                )
            );
        }

        this.store.dispatch(new SetCIAMDataLoaded(false));
        await this.authService.instance.initialize();
        await this.msalInstance.handleRedirectPromise();
        this.customerService.signOut().subscribe(() => {

        });
        // this.store.dispatch(new ClearAll());
        environment.LoggedInUser = '';
        this.store.dispatch(new SignOut());
        await this.msalInstance.handleRedirectPromise();
        const _azureSettings = this.appsetting.B2CIntegration?.AzureB2CIntegration;

        this.authService.logout({
            postLogoutRedirectUri:
                (_azureSettings)?.PostLogoutUrl ?? '',
        });
        // Redirect to Azure AD B2C logout URL
        var _tenantId = ((_azureSettings)?.Tenant.Id ?? "");
        var _logoutUrl = ((_azureSettings)?.LogoutUrl ?? "");
        // "https://" + _tenantId + ".b2clogin.com/" + _tenantId + ".onmicrosoft.com/oauth2/v2.0/logout"
        window.location.href = `${_logoutUrl}?post_logout_redirect_uri=${encodeURIComponent((_azureSettings)?.PostLogoutUrl ?? '')}`;

    }

    private async azureSilentLogin(fromCiamFlow: boolean, onSuccess: Function, onError: Function) {
        //   console.log(silentRequest)
        this.store.dispatch(new SetCIAMDataLoaded(false));
        await this.msalInstance.handleRedirectPromise();

        //  if (fromCiamFlow)
        {

            this.authService.ssoSilent(silentRequest).subscribe({
                next: async (result: AuthenticationResult) => {
                    console.log('SsoSilent succeeded!');
                    if (result && result.account) {
                        await this.processClaim(result.account)
                    }
                    if (onSuccess) {
                        onSuccess();
                    }
                },
                error: (error: any) => {
                    console.log(error);
                    if (fromCiamFlow) {
                        this.loginActionClick()
                    } else {
                        this.store.dispatch(new SetCIAMDataLoaded(true));
                        this.store.dispatch(new SetB2CContact(undefined));
                        let defaultContact = new Contact();
                        defaultContact.firstName = "";
                        defaultContact.profilePicture = "";
                        this.store.dispatch(new SetContactFromSilentLogin(defaultContact, null, null, null, null, null));
                        this.msalInstance.setActiveAccount(null);
                        if (onError) {
                            onError(error);
                        }
                    }
                },
            });
        }
    }

    private async processClaim(account: AccountInfo) {

        if (account &&
            account?.idTokenClaims &&
            (this.appsetting?.B2CIntegration?.AzureB2CIntegration?.ContactFieldMappings ?? []).length > 0
        ) {

            let _cn = this.mapClaimToContact(account);
            this.store.dispatch(new SetB2CContact(_cn));

            if (
                !this.loggedInDBContact ||
                !this.loggedInDBContact.id ||
                !this.loggedInDBContact.lastFetchedTime ||
                this.loggedInDBContact.lastFetchedTime < new Date(Date.now() - 3600 * 1000) //hourly load from DB

            ) {
                let _dbContact = await this.loadContactInfo(_cn && _cn.ssoContactRef ? _cn.ssoContactRef : '', _cn && _cn.email ? _cn.email : '');
                console.log(_dbContact);

            }

            //inactive contact or email alredy exists scenario
            if (this.loggedInDBContact && this.loggedInDBContact.id
                && (!(this.loggedInDBContact.active ?? false) ||
                    this.loggedInDBContact.ssoContactRef != (_cn?.ssoContactRef ?? ""))) {
                this.store.dispatch(new SetCIAMDataLoaded(true));
            } else {


                this.compareAndUpdate();
            }
        }
    }

    private mapClaimToContact(account: AccountInfo) {
        var _contact: { [key: string]: any } = JSON.parse(
            JSON.stringify(this.loggedInDBContact ?? {})
        );

        this.appsetting?.B2CIntegration?.AzureB2CIntegration?.ContactFieldMappings?.forEach(
            (item, index) => {
                var _arr = item.MappedTo.split('.');
                var _obj = _contact;
                _arr.forEach((arr, i) => {
                    if (i < _arr.length - 1) {
                        if (!_contact[arr]) {
                            _contact[arr] = {};
                        }
                        _obj = _contact[arr];
                    } else {
                        //last element
                        let _dt = Utility.getValueByKey(
                            account?.idTokenClaims,
                            item.Claim
                        );
                        if (arr == 'phone') {
                            if (Array.isArray(_dt)) {
                                _obj[arr] = _dt
                            } else {
                                _obj[arr] = [];
                                _obj[arr].push(_dt)
                            }
                        }
                        else if (arr == 'email') {
                            if (Array.isArray(_dt)) {
                                _obj[arr] = _dt[0]
                            } else {
                                _obj[arr] = _dt;
                            }
                        }
                        else {
                            _obj[arr] = _dt
                        }


                    }
                });
            }
        );
        let _cn = _contact as Contact;
        return _cn;
    }
    private compareAndUpdate() {
        if (this.loggedInDBContact && this.loggedInDBContact.id && this.b2cContact && this.b2cContact.ssoContactRef && this.b2cContact.ssoContactRef != '') {
            this.compareContact(this.b2cContact, this.loggedInDBContact);
        } else {
            this.store.dispatch(new SetCIAMDataLoaded(true));
        }

    }


    private async loadContactInfo(altRef: string, email: string = "") {
        if (altRef != "") {
            let filters: ContactFilters = {
                ssoContactRef: altRef,
                isFromLogin: true,
                disableSpinner: "1"
            };

            if (email !== null && email !== undefined && email !== '') {
                filters.EmailAddress = email;
            }

            let defaultContact = new Contact();
            defaultContact.firstName = "";
            defaultContact.profilePicture = "";

            try {
                const res = await (this.customerService.searchContacts(filters)).toPromise();
                console.log('Optimo Contact: ', res);
                let _contact: Contact | undefined = undefined;
                if (res) {
                    _contact = res;
                    _contact.lastFetchedTime = new Date();
                    this.store.dispatch(new SetContactFromSilentLogin(_contact, null, null, null, null, null));
                } else {
                    this.store.dispatch(new SetContactFromSilentLogin(defaultContact, null, null, null, null, null));
                }
                return _contact;
            } catch (error) {
                console.error('Error loading contact:', error);
                this.store.dispatch(new SetContactFromSilentLogin(defaultContact, null, null, null, null, null));
                return null;
            }
        } else {
            return null;
        }
    }

    private compareContact(
        ciamContact: Contact | undefined,
        dbContact: Contact | undefined
    ) {
        var _updatedContact: { [key: string]: any } = {};
        const contactFieldMappings = this.appsetting && this.appsetting.B2CIntegration && this.appsetting.B2CIntegration.AzureB2CIntegration
            ? this.appsetting.B2CIntegration.AzureB2CIntegration.ContactFieldMappings
            : [];

        contactFieldMappings.forEach(
            (item, index) => {
                if (item.MappedTo != 'email' && item.MappedTo != 'phone') {
                    var _arr = item.MappedTo.split('.');

                    var _objCIAM = JSON.parse(JSON.stringify(ciamContact ? ciamContact : {}));
                    var _objDB = JSON.parse(JSON.stringify(dbContact ? dbContact : {}));

                    if (_arr.length == 1) {
                        if (
                            Utility.getValueByKey(_objCIAM, _arr[0]) !=
                            Utility.getValueByKey(_objDB, _arr[0])
                        ) {
                            _updatedContact[_arr[0]] = Utility.getValueByKey(
                                _objCIAM,
                                _arr[0]
                            );
                        }
                    } else {
                        var _obj = JSON.parse(JSON.stringify(_updatedContact));
                        var _firstLevelAttribute = '';
                        var _firstLevelObj: any;
                        _arr.forEach((arr, i) => {
                            if (i == 0) {
                                if (!_obj[arr]) {
                                    _obj[arr] = {};
                                }
                                _firstLevelAttribute = arr;
                                _firstLevelObj = _obj[arr];
                            }

                            if (i < _arr.length - 1) {
                                if (!_obj[arr]) {
                                    _obj[arr] = {};
                                }
                                _obj = _obj[arr];
                                _objCIAM = _objCIAM[arr];
                                _objDB = _objDB[arr];
                            } else {
                                //last element
                                if (
                                    Utility.getValueByKey(_objCIAM, arr) !=
                                    Utility.getValueByKey(_objDB, arr)
                                ) {
                                    _obj[arr] = Utility.getValueByKey(_objCIAM, arr);
                                    _updatedContact[_firstLevelAttribute] = _firstLevelObj;
                                }
                            }
                        });
                    }
                } else {
                    //email mapping
                    if (item.MappedTo == 'email') {
                        var _email = '';
                        if (ciamContact && ciamContact.email && Array.isArray(ciamContact.email)) {
                            if (ciamContact.email.length > 0) {
                                ciamContact.email.forEach((item, index) => {
                                    _email = item || '';
                                });
                            }
                        } else {
                            _email = (ciamContact && ciamContact.email) ? ciamContact.email : '';
                        }

                        var _exi = (dbContact.communicationMethods && dbContact.communicationMethods.length > 0)
                            ? dbContact.communicationMethods.find(c => c.communicationTypeID == ((dbContact.customerType == 1) ? "6" : "5"))
                            : undefined;
                        if (!_exi || _exi.value != _email) {
                            if (!ciamContact.communicationMethods) {
                                ciamContact.communicationMethods = []
                            }
                            ciamContact.communicationMethods.push({
                                communicationTypeID: (dbContact && dbContact.customerType == 1) ? "6" : "5",
                                value: _email || '',
                            } as CommunicationMethod);

                            _updatedContact['communicationMethods'] = [{
                                id: (_exi && _exi.id ? _exi.id : ''),
                                communicationTypeID: (dbContact && dbContact.customerType == 1) ? "6" : "5",
                                value: _email,
                            }];
                        }

                    } else if (item.MappedTo == 'phone') {
                        //phone mapping
                        var _phone;

                        if (ciamContact && Array.isArray(ciamContact.phone)) {
                            if (ciamContact.phone.length > 0) {
                                ciamContact.phone.forEach((item) => {
                                    _phone = item || '';
                                });
                            }
                        } else {
                            _phone = (ciamContact && ciamContact.phone) ? ciamContact.phone : '';

                        }

                        var _exi = (dbContact.communicationMethods && dbContact.communicationMethods.length > 0) ?
                            dbContact.communicationMethods.find(c => c.communicationTypeID == ((dbContact.customerType == 1) ? "3" : "1")) :
                            null;

                        if (!_exi || _exi.value != _phone) {
                            if (!ciamContact.communicationMethods) {
                                ciamContact.communicationMethods = []
                            }
                            ciamContact.communicationMethods.push({
                                communicationTypeID: (dbContact && dbContact.customerType == 1) ? "3" : "1",
                                value: _phone,
                            } as CommunicationMethod);
                            _updatedContact['communicationMethods'] = [{
                                id: (_exi && _exi.id ? _exi.id : ''),
                                communicationTypeID: (dbContact && dbContact.customerType == 1) ? "3" : "1",
                                value: _phone,
                            }];
                        }
                    }
                }
            }
        );

        console.log(_updatedContact);
        var _keys = Object.keys(_updatedContact);
        //attribute pending for patch
        if (_keys.length > 0) {
            //map ids
            _updatedContact['id'] = dbContact ? dbContact.id : undefined;

            if (!_updatedContact['client']) {
                _updatedContact['client'] = {
                    Id: dbContact && dbContact.client ? dbContact.client.id : undefined,
                };
            }


            if (_updatedContact['address']) {
                if (dbContact && dbContact.customerType === 1) {
                    // individual
                    if (_updatedContact['address']) {
                        _updatedContact['client']['address'] = JSON.parse(
                            JSON.stringify(_updatedContact['address'])
                        );
                    }
                    if (dbContact.client && dbContact.client.address) {
                        _updatedContact['client']['address']['id'] = dbContact.client.address.id;
                    }
                    delete _updatedContact['address'];
                } else {
                    if (dbContact && dbContact.address) {
                        _updatedContact['address']['id'] = dbContact.address.id;
                    }
                    if (dbContact && dbContact.client && dbContact.client.address) {
                        const addressId = dbContact.client.address.id;

                        if (dbContact.address && dbContact.address.id !== addressId && this.isClientContactAddressSame(dbContact)) {
                            // Clone and update the address
                            _updatedContact['client']['address'] = JSON.parse(
                                JSON.stringify(_updatedContact['address'])
                            );
                            _updatedContact['client']['address']['id'] = addressId;
                        }
                    }
                }

            }

            //call customer patch
            _updatedContact['customerType'] = dbContact && dbContact.customerType ? dbContact.customerType : null;
            if (_updatedContact != null) {
                this.customerService.patchContactV2(_updatedContact).subscribe((res) => {
                    if (res) {
                        this.store.dispatch(new SetCIAMDataLoaded(true));
                    }
                });
            } else {
                this.store.dispatch(new SetCIAMDataLoaded(true));
            }
        } else {
            this.store.dispatch(new SetCIAMDataLoaded(true));
        }


    }

    private isClientContactAddressSame(dbContact: Contact) {
        return (
            (dbContact?.address?.address1 ?? '') ==
            (dbContact?.client?.address?.address1 ?? '') &&
            (dbContact?.address?.address2 ?? '') ==
            (dbContact?.client?.address?.address2 ?? '') &&
            (dbContact?.address?.address3 ?? '') ==
            (dbContact?.client?.address?.address3 ?? '') &&
            (dbContact?.address?.city ?? '') ==
            (dbContact?.client?.address?.city ?? '') &&
            (dbContact?.address?.country ?? '') ==
            (dbContact?.client?.address?.country ?? '') &&
            (dbContact?.address?.postCode ?? '') ==
            (dbContact?.client?.address?.postCode ?? '') &&
            (dbContact?.address?.stateCode ?? '') ==
            (dbContact?.client?.address?.stateCode ?? '') &&
            (dbContact?.address?.state ?? '') ==
            (dbContact?.client?.address?.state ?? '')
        );
    }





}
